export default "__VITE_ASSET__BA3lUUg1__"